'use client';

import { c as _c } from "react/compiler-runtime";
import { type FactiiiTag } from '@shared/all/domains/factiiis';
import { convertToFactiiiTag } from '@shared/utils/helpers/formatNumbers';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { Loader, Search } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../../utils/trpc';
import Input from '../../UI/Input';
import { FactiiiSearchResult } from '../FactiiiSearchResult';
type Props = {
  myPostFactiiiCounts: FactiiiTag[];
  handleClick: (tag: FactiiiTag) => void;
};
export const BotFactiii = t0 => {
  const $ = _c(32);
  const {
    myPostFactiiiCounts,
    handleClick
  } = t0;
  const [searchQuery, setSearchQuery] = useState("");
  let t1;
  if ($[0] !== searchQuery) {
    t1 = ["searchBotFactiiis", searchQuery];
    $[0] = searchQuery;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== myPostFactiiiCounts || $[3] !== searchQuery) {
    t2 = () => unwrapFromResult(client.search.factiiis.query({
      query: searchQuery,
      botsOnly: true,
      ignoredIds: myPostFactiiiCounts.map(_temp)
    }));
    $[2] = myPostFactiiiCounts;
    $[3] = searchQuery;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      refetchOnWindowFocus: false,
      placeholderData: _temp2,
      staleTime: 30000
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: searchResults,
    isLoading: searchLoading
  } = useQuery(t3);
  let t4;
  if ($[8] !== searchLoading) {
    t4 = [searchLoading ? <Loader key="loading-icon" className="animate-spin" /> : <Search key="search-icon" />];
    $[8] = searchLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== searchQuery || $[11] !== t4) {
    t5 = <Input autofocus={true} value={searchQuery} onChange={setSearchQuery} placeholder="Search for bots..." icons={t4} />;
    $[10] = searchQuery;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== searchLoading) {
    t6 = searchLoading && <div className="flex items-center justify-center py-4"><Loader className="animate-spin text-textSecondary" /></div>;
    $[13] = searchLoading;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleClick || $[16] !== myPostFactiiiCounts || $[17] !== searchLoading || $[18] !== searchQuery || $[19] !== searchResults?.factiiis) {
    bb0: {
      let t8;
      if ($[21] !== myPostFactiiiCounts) {
        t8 = new Set(myPostFactiiiCounts.map(_temp3));
        $[21] = myPostFactiiiCounts;
        $[22] = t8;
      } else {
        t8 = $[22];
      }
      const selectedIds = t8;
      const filtered = searchResults?.factiiis?.filter(f => !selectedIds.has(f.id)) ?? [];
      if (filtered.length > 0) {
        let t9;
        if ($[23] !== handleClick) {
          t9 = factiii => <FactiiiSearchResult key={factiii.id} tag={convertToFactiiiTag(factiii)} replyConfig={factiii.replyConfig} handleClick={() => handleClick(convertToFactiiiTag(factiii))} />;
          $[23] = handleClick;
          $[24] = t9;
        } else {
          t9 = $[24];
        }
        t7 = filtered.map(t9);
        break bb0;
      }
      if (!searchLoading && searchQuery.length > 0) {
        let t9;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <p className="py-4 text-center text-sm text-textSecondary">No bot factiiis found.</p>;
          $[25] = t9;
        } else {
          t9 = $[25];
        }
        t7 = t9;
        break bb0;
      }
      t7 = null;
    }
    $[15] = handleClick;
    $[16] = myPostFactiiiCounts;
    $[17] = searchLoading;
    $[18] = searchQuery;
    $[19] = searchResults?.factiiis;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <div className="mt-3 space-y-3">{t6}{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t5 || $[30] !== t8) {
    t9 = <div className="flex flex-col">{t5}{t8}</div>;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
function _temp(bot) {
  return bot.factiiiId;
}
function _temp2(previousData) {
  return previousData;
}
function _temp3(t) {
  return t.factiiiId;
}